import { forwardRef, type Ref, type SVGProps } from "react";
const IconSchoolOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 28h-1v-6h1a1 1 0 0 0 0-2h-8.47c2.19-2 3.47-6.55 3.47-8a4.83 4.83 0 0 0-4.94-5 5.5 5.5 0 0 0-2.06.55V7a.92.92 0 0 1 1-1 1 1 0 0 0 0-2 2.91 2.91 0 0 0-3 3v.55A5.5 5.5 0 0 0 12.94 7 4.83 4.83 0 0 0 8 12c0 1.45 1.28 6 3.47 8H5a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h24a1 1 0 0 0 0-2M10 12a2.84 2.84 0 0 1 2.94-3 4.7 4.7 0 0 1 1.64.57 2.86 2.86 0 0 0 1.42.36 2.8 2.8 0 0 0 1.41-.36A4.8 4.8 0 0 1 19.06 9 2.84 2.84 0 0 1 22 12c0 1.83-2.12 7-3.67 7a2.4 2.4 0 0 1-.84-.33 2.85 2.85 0 0 0-3 0 2.6 2.6 0 0 1-.84.33C12.12 19 10 13.83 10 12m16 16H4.89a1 1 0 0 1 0-2H26Zm0-4H5a1 1 0 0 1 0-2h21Z" />
  </svg>
);
const ForwardRef = forwardRef(IconSchoolOutlineSVG);
ForwardRef.displayName = "IconSchoolOutline";
export { ForwardRef as IconSchoolOutline };
